import { render, staticRenderFns } from "./AddNewMarketModal.vue?vue&type=template&id=29736b3c&scoped=true&"
import script from "./AddNewMarketModal.vue?vue&type=script&lang=js&"
export * from "./AddNewMarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29736b3c",
  null
  
)

export default component.exports